import React from 'react';
import './EducationTwoTestimonials.scss';

const EducationTwoTestimonials = () => {
  const testimonials = [
    {
      id: 1,
      text: "TutorTot has helped me find Tuitons with ease and i m very happy with them. The service is very good. I recommend it to all Tutors.",
      name: "Kunika Gera",
      tag: "insightful",
      image: "https://themes.envytheme.com/edali/wp-content/uploads/2020/02/user1.jpg"
    },
    {
      id: 2,
      text: "I was very impressed by the company service. The platform made it so easy to connect with students and manage my tutoring schedule efficiently.",
      name: "Rahul Sharma",
      tag: "helpful",
      image: "https://randomuser.me/api/portraits/men/32.jpg"
    },
    {
      id: 3,
      text: "As a parent, I found exactly the right tutor for my child's needs. The matching system works wonderfully and saved us so much time.",
      name: "Priya Patel",
      tag: "satisfied",
      image: "https://randomuser.me/api/portraits/women/44.jpg"
    },
    {
      id: 4,
      text: "Excellent platform for tutors. I've doubled my students since joining and the payment system is very reliable.",
      name: "Amit Singh",
      tag: "professional",
      image: "https://randomuser.me/api/portraits/men/75.jpg"
    }
  ];

  return (
    <section className="horizontal-testimonials   education_two_sect_padding 
">
      <div className="container">
        <div className="section-header">
         <h3 className="sect_title">
            Why{" "}
            <span className="relative">
              People
              <span className="title-shape">
                <svg
                  width="150"
                  height="65"
                  viewBox="0 0 168 65"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="highligt_text"
                >
                  <path
                    d="M73.3761 8.49147C78.4841 6.01353 82.5722 4.25154 88.8933 3.3035C94.2064 2.50664 99.6305 2.0701 104.981 1.94026C120.426 1.56549 135.132 4.90121 146.506 9.70405C158.628 14.8228 166.725 22.5638 166.074 31.6501C165.291 42.5779 151.346 51.7039 133.508 56.8189C110.253 63.4874 81.7065 63.8025 58.5605 60.8285C37.5033 58.123 11.6304 51.7165 3.58132 40.0216C-3.43085 29.8337 12.0728 18.1578 27.544 11.645C40.3656 6.24763 55.7082 2.98328 70.8043 4.08403C81.9391 4.89596 93.2164 6.87822 102.462 9.99561C112.874 13.5066 120.141 18.5932 127.862 23.6332"
                    stroke="var(--click-color)"
                    strokeWidth="3"
                    strokeLinecap="round"
                  ></path>
                </svg>
              </span>
            </span>{" "}
          Say.
          </h3>
        </div>
        
        <div className="testimonials-scroller">
          <div className="testimonials-track">
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="testimonial-card">
                <p className="testimonial-text">"{testimonial.text}"</p>
                <div className="testimonial-footer">
                  <div>
                    <h3 className="testimonial-name">{testimonial.name}</h3>
                    <span className="testimonial-tag">{testimonial.tag}</span>
                  </div>
                  <div className="testimonial-image">
                    <img 
                      src={testimonial.image} 
                      alt={testimonial.name} 
                      loading="lazy"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default EducationTwoTestimonials;